module.exports = __webpack_public_path__ + "static/media/bGuthrie.f23c881b.jpeg";